export default __webpack_public_path__ + "static/media/AT003.e550d42c.mp3";